/* Protection douce des visuels : pas de clic droit, pas de glisser-déposer, pas de menu « enregistrer l'image »
   sur les aperçus et les créations. (Une capture d'écran reste possible : les aperçus portent un filigrane.) */
(function () {
  "use strict";
  var SEL = [
    ".live-poster", ".orbes-stage", ".orbes-frame", ".sky-final__frame", ".sky-creator__stage", ".sky-gallery", ".sky-frames",
    ".poster-frame", ".pdp-mockup", ".product-card__image", ".collection-wall", ".mockup-duo", ".pv__mockups", ".hero-mockup", ".about__figure",
    "[data-sky-creator-canvas]", "[data-sky-poster-canvas]", ".size-guide__stage"
  ].join(",");
  function protectedTarget(e) { return !!(e.target && e.target.closest && e.target.closest(SEL)); }
  document.addEventListener("contextmenu", function (e) { if (protectedTarget(e)) e.preventDefault(); });
  document.addEventListener("dragstart", function (e) { if (protectedTarget(e)) e.preventDefault(); });
  document.addEventListener("copy", function (e) {
    var sel = window.getSelection && window.getSelection();
    if (sel && sel.anchorNode && sel.anchorNode.parentElement && sel.anchorNode.parentElement.closest && sel.anchorNode.parentElement.closest(".live-poster")) e.preventDefault();
  });
})();
